export default "__VITE_ASSET__DLCZpNnj__"